import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import {
    getTimesheets,
    getAdminTimesheets,
    findTimesheets,
    getTimesheetShifts,
    getApprovedTimesheets,
    getPendingTimesheets
} from '../../../../../../reducers/timekeeping';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import { getAdminDetails } from '../../../../../../reducers/users';
import Table from '../../../../../../components/table';
import TimesheetActions from './../../../../dialogs/timesheetActions';
import { renderPeriodEnding, renderHours } from '../../_common';

class ContractorTimesheetsList extends React.Component {
    constructor(props) {
        super(props);

        this.initialize = this.initialize.bind(this);
        this.getColumnDefinition = this.getColumnDefinition.bind(this);
    }
    initialize() {
        const { details, job, getAdminDetails, findTimesheets } = this.props;
        getAdminDetails(details.admin_id, () => findTimesheets(job.id, undefined, moment.tz(job.work_timezone)));
    }

    getColumnDefinition() {
        const { job, shifts, workers, getTimesheetShifts } = this.props;
        const getJob = timesheet => {
            return job && typeof job === 'object' ? job : workers.find(w => w.id === timesheet.job_id);
        };

        const renderColumn = timesheet => dom => (
            <TimesheetActions
                key={timesheet.id}
                job={getJob(timesheet)}
                timesheet={timesheet}
                component={dom}
                shifts={shifts[timesheet.id] || []}
                reloadData={() => getTimesheetShifts(timesheet.id, this.initialize)}
            />
        );

        return [
            {
                label: <FormattedMessage {...messages.periodEnding} />,
                valueMap: d => renderColumn(d)(action => renderPeriodEnding(action, d, d.job)),
                size: 'col-xs-4 col-sm-3 col-md-2 col-xl-1',
                sort: (a, b) => new Date(a.period_ending || a.created_at).getTime() - new Date(b.period_ending || b.created_at).getTime()
            },
            {
                label: <FormattedMessage {...messages.hours} />,
                valueMap: d => renderColumn(d)(action => renderHours(action, d.minutes, d.expense_total, d.deliverable_total)),
                size: 'col-xs-4 col-sm-3 col-md-2 col-xl-1 text-right',
                sort: (a, b) => (a.minutes || 0) - (b.minutes || 0)
            },
            {
                label: <FormattedMessage {...messages.status} />,
                valueMap: d =>
                    renderColumn(d)(action => (
                        <div className="full-height-cell ellipsis clickable" onClick={action}>
                            {d.status}
                        </div>
                    )),
                size: 'col-xs-4 col-sm-3',
                sort: (a, b) => a.status.localeCompare(b.status)
            }
        ];
    }

    render() {
        const { timesheets } = this.props;
        if (!timesheets) return null;
        if (timesheets.length === 0) {
            return (
                <div className="col-xs-12 timesheet-list">
                    <div className="empty-list">
                        <FormattedMessage {...messages.noTimesheetsFound} />
                    </div>
                </div>
            );
        }

        return <Table data={timesheets} columns={this.getColumnDefinition()} defaultSortColumn={0} defaultSortDesc={true} />;
    }
}

ContractorTimesheetsList.defaultProps = {
    job: undefined,
    workers: undefined,
    filter: 'all'
};
ContractorTimesheetsList.defaultProps = {
    job: PropTypes.object,
    workers: PropTypes.array,
    filter: PropTypes.oneOf(['all', 'pending', 'approved'])
};

const mapStateToProps = state => {
    return {
        role: state.identity.role,
        details: state.identity.details,
        admin: state.users.adminDetails,
        timesheets: state.timekeeping.rangeTimesheets,
        shifts: state.timekeeping.timesheetShifts
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdminDetails,
            findTimesheets,
            getTimesheets,
            getApprovedTimesheets,
            getPendingTimesheets,
            getAdminTimesheets,
            getTimesheetShifts
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractorTimesheetsList);



// WEBPACK FOOTER //
// ./src/pages/timekeeping/lists/timesheets/tenants/contractor/index.jsx